import { Component, OnInit, ChangeDetectorRef, NgZone } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NotificationService } from 'app/common/clientSerivces/notification.service';
import { AppServices } from 'app/servicelayer/app-services';
import { SharedModule } from 'app/common/sharedComponents/shared.module';

@Component({
    selector: 'app-login',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, RouterModule,SharedModule],
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit
{
    loginForm: FormGroup;

    showBtn: boolean = true;
    loader: boolean = false;
    showPassword: boolean = false;

    constructor(
        private router: Router,
        public notificationService: NotificationService,
        private fb: FormBuilder,
        private cdr: ChangeDetectorRef,
        private ngZone: NgZone,
        private services: AppServices
    )
    {
        this.loginForm = this.fb.group({
            username: ['', Validators.required],
            password: ['', Validators.required]
        });
    }

    ngOnInit(): void
    {
        console.log('LoginComponent initialized');
        console.log('Current URL:', this.router.url);
        
        // Log query parameters for debugging
        const queryParams = this.router.parseUrl(this.router.url).queryParams;
        console.log('Login page query params:', queryParams);
        
        if (queryParams.sessionTimeout) {
            console.log('User arrived due to session timeout');
            this.notificationService.showError('Your session has expired. Please log in again.', 'Session Expired');
        }
        
        this.cdr.detectChanges();
    }

    get getLoginFormControls()
    {
        return this.loginForm.controls;
    }

    togglePasswordVisibility(): void
    {
        this.showPassword = !this.showPassword;
    }

    login(): void
    {
        this.ngZone.run(() =>
        {
            console.log('Login button clicked');
            console.log('Form valid:', this.loginForm.valid);
            console.log('Username:', this.loginForm.value.username);

            if (!this.loginForm.valid)
            {
                this.notificationService.showError('Please enter username and password', '');
                return;
            }

            this.showBtn = false;
            this.cdr.markForCheck();

            console.log('Login: Initializing authentication services for login attempt');
            // Ensure authentication services are available for login
            this.services.authenticationService.login(
                this.loginForm.value.username,
                this.loginForm.value.password
            ).subscribe(
                (response) =>
                {
                    this.ngZone.run(() =>
                    {
                        console.log('Login response:', response);
                        if (response)
                        {
                            console.log('Login successful - SharedComponents loading spinner handles UI');

                            // Reset form state
                            this.showBtn = true;
                            this.cdr.detectChanges();

                            console.log('Login successful - waiting for authentication service to handle redirect');

                            // Add a fallback redirect in case the authentication change detection doesn't work
                            setTimeout(() => {
                                // Check if we're still on the login page after 2 seconds
                                if (this.router.url.includes('login')) {
                                    console.log('Login: Still on login page after 2 seconds, manually redirecting to dashboard');
                                    this.router.navigate(['/hr/Dashboard']);
                                }
                            }, 2000);

                            // Redirect will be handled by the authentication change detection in app-initialization.service
                        } else
                        {
                            console.log('Login failed - invalid credentials');
                            this.notificationService.showError('Invalid Credentials', '');
                            this.showBtn = true;
                            this.cdr.detectChanges();
                        }
                    });
                },
                (error) =>
                {
                    this.ngZone.run(() =>
                    {
                        console.error('Login error:', error);
                        this.notificationService.showError('Login failed. Please try again.', '');
                        this.showBtn = true;
                        this.cdr.detectChanges();
                    });
                }
            );
        });
    }

    trueFalse(): void
    {
        // Callback functionality if needed
        this.loader = true;
        setTimeout(() =>
        {
            this.loader = false;
        }, 2000);
    }
}
